export function viewFitSelectionAction() {
  const { t } = useI18n();
  const { $math } = useNuxtApp();

  return {
    getTitle: () =>
      t('components.xeokit_viewer.context_menu.view_fit_selection') || 'View Fit Selected',

    getEnabled: (context) => {
      return context.viewer.scene.numSelectedObjects > 0;
    },

    doAction: (context) => {
      const viewer = context.viewer;
      const scene = viewer.scene;
      const sceneAABB = scene.getAABB(scene.selectedObjectIds);

      viewer.cameraFlight.flyTo({
        aabb: sceneAABB,
        duration: 0.5,
      });

      viewer.cameraControl.pivotPos = $math.getAABB3Center(sceneAABB);
    },
  };
}
